import { isEmpty } from 'lodash';
import { CellData, TableContentData } from '../../../../../../../common/table/TableTypes';
import { createEmptyTableCellEntry } from '../../../../../../../common/table/utils/tableInitialisationUtils';
import { applyInferredCellType } from './tableCellTypeInferenceUtils';

export const createTableCellEntryFromValue = (value: string | null = null, locale = 'en-US'): CellData => {
    if (isEmpty(value) || !value) return createEmptyTableCellEntry();

    return applyInferredCellType({ value }, null, locale) || { value };
};

export const createTableContentDataFromValues = (
    values: Array<Array<string | null>>,
    locale: string,
): TableContentData => {
    return values.map((row) => row.map((value) => createTableCellEntryFromValue(value, locale)));
};
